module.exports={
   "type": "FeatureCollection",
   "features": [
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.3349482,48.4808307 ]
    },
    "properties": {
    "Name":"Tacos Tecalitlan",
    "Address":"702 N. Burlington Blvd., Burlington",
    "Type":"Pork",
    "Taco":"Chicharron taco ($1.95 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.2012932,47.6147878 ]
    },
    "properties": {
    "Name":"Cantina Monarca",
    "Address":"504 Bellevue Way N.E., Bellevue",
    "Type":"Pork",
    "Taco":"Sakura pork belly ($10 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.3551471,47.6911072 ]
    },
    "properties": {
    "Name":"La Conasupo Taqueria & Snack Shop",
    "Address":"8532 Greenwood Ave. N., Seattle",
    "Type":"Lamb",
    "Taco":"Lamb rib (3 for $5.99)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.2997533,47.5994896 ]
    },
    "properties": {
    "Name":"Standard Brewing",
    "Address":"2504 S. Jackson St., Seattle",
    "Type":"Meatless",
    "Taco":"Smoked carrot taco ($4 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.4918607,47.1562262 ]
    },
    "properties": {
    "Name":"Los Cuervos",
    "Address":"11109 Pacific Highway S.W., Lakewood",
    "Type":"Pork",
    "Taco":"Tacos de Trompo ($3.75 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.2796928,47.5369291 ]
    },
    "properties": {
    "Name":"Bang Bang Kitchen",
    "Address":"4219 S. Othello St., Seattle",
    "Type":"Beef",
    "Taco":"Hard-shell \"Mama's taco\" ($17.50 per dinner plate)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.3837548,47.6665588 ]
    },
    "properties": {
    "Name":"Gracia",
    "Address":"5313 Ballard Ave. N.W., Seattle",
    "Type":"Beef",
    "Taco":"Oaxacan-style brisket barbacoa ($6.50 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.3454667,48.4214553 ]
    },
    "properties": {
    "Name":"Cocina Sabores",
    "Address":"810 W. Division, Mount Vernon",
    "Type":"Beef",
    "Taco":"Barbacoa taco ($4.50 each — on weekends only!)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.3132603,47.5807076 ]
    },
    "properties": {
    "Name":"Carnitas Michoacan",
    "Address":"2500 Beacon Ave. S., Seattle",
    "Type":"Seafood",
    "Taco":"Tacos gobernadora de camaron ($17.99 for three)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.295277,47.6686532 ]
    },
    "properties": {
    "Name":"Pancita at Pair",
    "Address":"5501 30th Ave. N.E., Seattle",
    "Type":"Beef",
    "Taco":"Brisket suadero taco ($11 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.3541982,47.5160141 ]
    },
    "properties": {
    "Name":"El Catrin",
    "Address":"9641 15th Ave. S.W., White Center",
    "Type":"Beef",
    "Taco":"Taco de suadero ($3.99 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.384869,47.6669245 ]
    },
    "properties": {
    "Name":"Asadero ",
    "Address":"5405 Leary Ave. N.W., Seattle; 310 Washington Ave. N., Kent",
    "Type":"Beef",
    "Taco":"Rib-eye taco ($19.99 for 4)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.3240146,47.4394038 ]
    },
    "properties": {
    "Name":"Birrieria La Santa Tacos & More",
    "Address":"18205 Des Moines Memorial Drive, SeaTac",
    "Type":"Beef",
    "Taco":"Street-style carne asada ($4 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.3392458,47.5682924 ]
    },
    "properties": {
    "Name":"Jack’s BBQ ",
    "Address":"3924 Airport Way. S. Seattle; 228 Ninth Ave. N., Seattle",
    "Type":"Beef",
    "Taco":"Beef rib taco ($7 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.2722421,47.5410401 ]
    },
    "properties": {
    "Name":"Tacos Los Potrillos (food truck)",
    "Address":"6815 Rainier Ave. S., Seattle",
    "Type":"Beef",
    "Taco":"Tripas tacos ($3 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.3491604,47.4879266 ]
    },
    "properties": {
    "Name":"Birrieria Tijuana",
    "Address":"1111 S.W. 128th St., Burien",
    "Type":"Beef",
    "Taco":"Queso birria taco ($4 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.280917,47.4558896 ]
    },
    "properties": {
    "Name":"Tacos El Patron (food truck)",
    "Address":"16402 Military Road S., SeaTac",
    "Type":"Pork",
    "Taco":"Acorazados ($4.99 with meat)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.335323,47.4656955 ]
    },
    "properties": {
    "Name":"Burien Fish House",
    "Address":"133 S.W. 153rd St., Burien",
    "Type":"Seafood",
    "Taco":"Cod taco ($11 for two)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.2230467,47.8608136 ]
    },
    "properties": {
    "Name":"Azul Restaurant & Lounge",
    "Address":"15118 Main St. #100, Mill Creek",
    "Type":"Seafood",
    "Taco":"Grilled shrimp taco ($19.50 for two)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.4204711,47.1913485 ]
    },
    "properties": {
    "Name":"La Oveja Negra Eatery",
    "Address":"806 72nd St. E., Tacoma",
    "Type":"Lamb",
    "Taco":"Barbacoa taco ($4 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.0380824,47.5383981 ]
    },
    "properties": {
    "Name":"Xochi Tacos",
    "Address":"145 N.W. Gilman Road, Issaquah",
    "Type":"Meatless",
    "Taco":"Rajas con crema taco ($4.25 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.3536389,47.5122504 ]
    },
    "properties": {
    "Name":"Taqueria la Fondita",
    "Address":"10050 15th Ave. S.W., White Center",
    "Type":"Beef",
    "Taco":"Lengua beef tongue taco ($3.29 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.3054178,47.6126685 ]
    },
    "properties": {
    "Name":"El Costeno",
    "Address":"2015 E. Union St., Seattle",
    "Type":"Chicken",
    "Taco":"Oaxaca mole ($2.50 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.1614695,47.7519977 ]
    },
    "properties": {
    "Name":"Lifted Taco",
    "Address":"17255 135th Ave. N.E., Suite 1040, Woodinville",
    "Type":"Meatless",
    "Taco":"Kentucky Fried Cauliflower ($6.25 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.3777915,48.5153547 ]
    },
    "properties": {
    "Name":"The Oyster Shuckers: Oyster Bar & Taqueria",
    "Address":"17026 Allen W. Road, Bow",
    "Type":"Miscellaneous",
    "Taco":"Steak and shrimp taco ($3.50 each)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.3413362,47.4661366 ]
    },
    "properties": {
    "Name":"Casa Mixteca",
    "Address":"452 S.W. 153rd St., Burien",
    "Type":"Miscellaneous",
    "Taco":"Chapulín or roasted grasshopped tacos (3 for $15.99)"
    }
  },
  {
    "type": "Feature",
    "geometry": {
       "type": "Point",
       "coordinates":  [ -122.2173358,47.9423678 ]
    },
    "properties": {
    "Name":"El Mariachi Birria Y Tacos",
    "Address":"6100 Evergreen Way, Everett",
    "Type":"Chicken",
    "Taco":"Queso taco ($4 each)"
    }
  }
]
}